export enum InitiativeStatus {
  ProposedUnder = 'Proposed or under development',
  Active = 'Active',
  Complete = 'Inactive – initiative complete',
  InitiativeNotInitiated = 'Inactive – initiative not initiated'
}
